type JsonObject = { [key: string]: string | JsonObject };

export function flattenJson(obj: JsonObject): { [path: string]: string } {
    const result: { [path: string]: string } = {};

    function recurse(current: string | JsonObject, path: string) {
        // If 'current' is an object and not null (which is also typeof 'object')
        if (typeof current === 'object' && current !== null) {
            // Iterate over the keys of the current object
            Object.keys(current).forEach(key => {
                const newPath = path ? `${path}.${key}` : key;
                // Recursively call 'recurse' for the nested value and the new path
                recurse(current[key], newPath);
            });
        } else {
            result[path] = current;
        }
    }

    // Start the recursion from the root object with an empty path
    recurse(obj, '');

    return result;
}

export function unflattenJson(flattenedObject: { [path: string]: string }): JsonObject {
    const result: JsonObject = {};

    // Iterate over each path-value pair in the flattened object
    Object.keys(flattenedObject).forEach(path => {
        const value = flattenedObject[path];
        // Split the path into individual keys
        const keys = path.split('.');

        let currentLevel: JsonObject = result;

        // Traverse the keys, creating nested objects as needed
        for (let i = 0; i < keys.length; i += 1) {
            const key = keys[i];

            // If it's the last key in the path, assign the value
            if (i === keys.length - 1) {
                currentLevel[key] = value;
            } else {
                // If the current key doesn't exist or is not an object, create an empty object
                if (typeof currentLevel[key] !== 'object' || currentLevel[key] === null) {
                    currentLevel[key] = {};
                }
                // Move to the next level of nesting
                currentLevel = currentLevel[key] as JsonObject;
            }
        }
    });

    return result;
}
